module.exports = __webpack_public_path__ + "img/rebuild_huang_pc1.c784d92c.jpg";